'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreadCanAddAvailabilityMessage = exports.default = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _hasChatMessageFromAgent = require('conversations-schema/thread-history/operators/hasChatMessageFromAgent');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var _getConversations = require('../../selectors/conversationSelectors/getConversations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getThreadCanAddAvailabilityMessage(state) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      channel = _ref.channel;

  var conversations = (0, _getConversations.getConversations)(state);

  var thread = (0, _get2.default)(channel, conversations);

  var threadHistory = (0, _historyDataForThread.historyDataForThread)(state, { thread: thread });

  return !threadHistory || !(0, _hasChatMessageFromAgent.hasChatMessageFromAgent)(threadHistory);
}

exports.default = getThreadCanAddAvailabilityMessage;
exports.getThreadCanAddAvailabilityMessage = getThreadCanAddAvailabilityMessage;


//////////////////
// WEBPACK FOOTER
// ./js/availability/selectors/getThreadCanAddAvailabilityMessage.js
// module id = 580
// module chunks = 2 3